<div class="right-panel h-100">
  <div class="h-100 d-flex flex-column">
    <fieldset *ngIf="showServiceConnectInfo && isMonitor == false" class="p-4" style="background-color: #f1f1f1;">
      <div>
        <p>Follow below instructions to enable upload/download of storage.</p>
        <ol>
          <li>Click <a style="z-index: 2; color: blue; text-decoration: underline; cursor: pointer;" (click)="redirectToVmIP()">here</a>. you will be redirected to permissions page.</li>
          <li>Click on "Advanced".</li>
          <li>Click on "Proceed to {{vmIp}} ( unsafe )".</li>
        </ol>
      </div>
    </fieldset>
    <div class="position-relative flex-grow-1">
      <table class="table table-striped" *ngIf="storage">
        <thead>
          <tr>
            <th>Property</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Infrastructure</td>
            <td>{{ storage.cloud }}</td>
          </tr>
          <tr>
            <td>Deployment</td>
            <td>{{ storage.deployment }}</td>
          </tr>
          <tr>
            <td>Location</td>
            <td>{{ storage.location }}</td>
          </tr>
          <tr>
            <td>Name</td>
            <td>{{ storage.name }}</td>
          </tr>
          <tr>
            <td>Type</td>
            <td>{{ storage.type }}</td>
          </tr>
          <tr>
            <td>Syncstore Usage</td>
            <td>{{ storage.syncStoreUsage || "NA" }}</td>
          </tr>
          <tr>
            <td>Workstore Usage</td>
            <td>{{ storage.workStoreUsage || "NA" }}</td>
          </tr>
          <tr *ngIf="isOnPremise">
            <td>Key1</td>
            <td class="keys">
              <input
                #key1Inp
                [type]="!fieldTextType1 ? 'text' : 'password'"
                class="propInp"
                value="{{ storage.key1  }}"
                readonly
              />
              <span
                *ngIf="isMonitor == false"
                (click)="togglePassswordIcon1()"
                class="bi"
                [ngClass]="{
                  'bi-eye-fill': fieldTextType1,
                  'bi-eye-slash-fill': !fieldTextType1
                }"
              ></span>
              <span
                *ngIf="!fieldTextType1"
                class="bi bi-clipboard"
                placement="bottom" 
                triggers="hover" ngbTooltip="Copy to Clipboard"
                [cdkCopyToClipboard]="key1Inp.value"
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
      <ngx-spinner
        bdColor="rgba(0,0,0,0)"
        size="default"
        zIndex="1"
        color="var(--s-primary-color)"
        type="ball-spin"
        [fullScreen]="false"
        ><p class="pleaseWait mt-2">Loading properties ...</p></ngx-spinner
      >
    </div>
  </div>
</div>
